module.exports = __webpack_public_path__ + "img/fleche_bas.svg";